import util from './util';

export default util;
export const defaultImg = 'https://image.jkzgxd.cn/tos-cn-i-a3h8qa8x9l/8750d228b0bd4f8aa2987ef297191eae~tplv-a3h8qa8x9l-png.png?';
export { default as Storage } from './Storage';
export { default as Env } from './env';
export { default as Regular } from './regular';
